import { act } from './act';
import { nsw } from './nsw';
import { nt } from './nt';
import { qld } from './qld';
import { vic } from './vic';

const urls = [qld, nsw, nt, vic, act];

export default urls;
